export default {
  LOCAL: 'LOCAL',
  EVERY: 'EVERY'
}
